/* eslint-disable react/no-access-state-in-setstate */
import React, { Component } from 'react'
import classnames from 'classnames'
import { Modal, Input, message, Upload } from 'antd'
import insImg from 'image/ins_coll_qrcode.png'
import Icon from 'meinian-package/src/component/icon'
import request from 'meinian-package/src/utils/request'
import Button from 'meinian-package/src/baseComponent/button'
import './index.less'

const CDN_HOST = 'https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/'
const CDN_DIR = 'ins-selected/'
const GET_TOKEN_API = '/upload/get-oss-upload-token'
const MAX_LENGTH = 300
const MAX_SIZE = 5// 5m
let token = {}
function unionid(mime) {
  return `${CDN_DIR + new Date().getTime()}_${Math.random().toString(32).substr(2, 10)}${mime || '.png'}`
}
async function initToken() {
  const result = await request.get(GET_TOKEN_API)
  const res = result.sign
  token = {
    OSSAccessKeyId: res.accessid,
    signature: res.signature,
    key: res.key,
    policy: res.policy
  }
  return { host: res.host, token }
}
function Image({ src, className, onRemove }) {
  return <div
    className={classnames(className, 'feedback-dialog-image')}
    style={{
      backgroundImage: `url(${src})`
    }}
  >
    <Icon type="m-guanbi" className="close" onClick={onRemove} />
  </div>
}
class Index extends Component {
  static defaultProps = {
    visible: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClose() {}
  }

  state = {
    content: '',
    images: [],
    uploading: false
  }

  uploadHandle = {
    name: 'file',
    multiple: false,
    accept: '.png,.jpeg,.jpg,.bmp',
    showUploadList: false,
    customRequest: async ({ file }) => {
      const res = await initToken()
      const key = unionid()
      if (file.size / 1024 / 1024 > MAX_SIZE) {
        message.error(`文件大小不能超过${MAX_SIZE}M`)
        return
      }
      this.setState({ uploading: true })
      await request.formdata(res.host, {
        ...res.token,
        success_action_status: 200,
        key,
        file
      })
      this.state.images.push(CDN_HOST + key)
      this.setState({ images: this.state.images, uploading: false })
    },
  }

  // eslint-disable-next-line react/no-deprecated
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.visible !== this.props.visible && nextProps.visible) {
      this.setState({
        content: '',
        images: []
      })
    }
  }

  onQuit() {
    this.props.onClose()
  }

  async onSubmit() {
    try {
      await request.get('/feed/back/add', {
        params: {
          content: this.state.content,
          imgUrls: this.state.images.join(',')
        }
      })
      message.success('意见提交成功')
      this.props.onClose()
    } catch (error) {
      console.error(error)
      message.error('提交失败')
    }
  }

  onRemoveImage(item) {
    this.setState({
      images: this.state.images.filter(m => m !== item)
    })
  }

  renderFooter() {
    const { content, uploading } = this.state
    return (
      <div>
        <Button type="normal" className="ghost" ghost onClick={this.onQuit.bind(this)}>
          取消
        </Button>
        <Button
          type="primary"
          className="primary"
          style={{ marginLeft: 16 }}
          loading={uploading}
          disabled={content.trim().length === 0 || uploading}
          onClick={this.onSubmit.bind(this)}
        >
          确定
        </Button>
      </div>
    )
  }

  render() {
    const { content, images } = this.state
    return <Modal
      className="feedback-modal"
      onCancel={this.onQuit.bind(this)}
      visible={this.props.visible}
      footer={this.renderFooter()}
      width={681}
      height={517}
      closable
    >
      <div className="feedback-dialog-content">
        <div className="title">意见反馈</div>
        <div className="desc">请描述您的建议或遇到的问题<span>（若您遇到亟待解决的问题，也可以添加人工客服反馈）</span>
        </div>
        <div style={{ position: 'relative' }}>
          <Input.TextArea
            maxLength={MAX_LENGTH}
            placeholder="请输入反馈内容"
            rows={4}
            value={content}
            // autoSize={true}
            autosize={{
              minRows: 4,
              maxRows: 10
            }}
            onChange={e => this.setState({ content: e.target.value })}
          />
          <span style={{ position: 'absolute', right: 8, bottom: 8, color: '#c8c9d7' }}> {content.length}/{MAX_LENGTH}</span>
        </div>
        <div>
          <div className="desc">上传图片（选填）</div>
          <p style={{ margin: '0 -8px' }}>
            {images.map(m => <Image src={m} onRemove={this.onRemoveImage.bind(this, m)} />)}
            {images.length < 3 && <Upload {...this.uploadHandle}>
              <div className="feedback-modal-upload-area">
                +
              </div>
            </Upload>}
          </p>
          <div className="info">*仅支持jpg、png、jpeg格式的图片，且文件小于{MAX_SIZE}M</div>
        </div>
        <div className="service">人工客服<div className="service-card">
          <img src={insImg} alt="人工客服" width={114} style={{ marginBottom: 10 }} />
          <span className="txt-info">微信扫一扫，添加人工客服</span>
        </div></div>
      </div>
    </Modal>
  }
}

export default Index
